module.exports = __webpack_public_path__ + "static/media/internet.facc743d.svg";